import {
  ADD_NEW_INTERVIEWER,
  ADD_NEW_INTERVIEWER_FAILED,
  ADD_NEW_INTERVIEWER_SUCCESS,
  GET_INTERVIEWERS_DATA,
  GET_INTERVIEWERS_DATA_SUCCESS,
  GET_SCHEDULER_INTERVIEW_DETAILS,
  GET_SCHEDULER_INTERVIEW_DETAILS_FAIL,
  GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS,
  POST_INTERVIEW_ROUND,
  POST_INTERVIEW_ROUND_FAIL,
  POST_INTERVIEW_ROUND_SUCCESS,
  REJECT_CANDIDATE,
  REJECT_CANDIDATE_FAILURE,
  REJECT_CANDIDATE_SUCCESS,
  SCHEDULE_INTERVIEW,
  SCHEDULE_INTERVIEW_FAILURE,
  SCHEDULE_INTERVIEW_SUCCESS,
  UPDATE_INTERVIEW_DETAILS,
  UPDATE_INTERVIEW_DETAILSS_FAIL,
  UPDATE_INTERVIEW_DETAILS_SUCCESS,
  GET_INTERVIEW_ROUNDS,
  GET_INTERVIEW_ROUNDS_SUCCESS,
  GET_INTERVIEW_ROUNDS_FAILURE,
  GET_INTERVIEWERS_DATA_ERROR,
  GET_INTERVIEW_RECORDINGS,
  GET_INTERVIEW_RECORDINGS_SUCCESS,
  GET_INTERVIEW_RECORDINGS_FAILURE,
} from "./actionTypes";

/**get schedule interviewe data */
export const getScheduleInterviewDetails = (jobId, candidateId) => {
  return {
    type: GET_SCHEDULER_INTERVIEW_DETAILS,
    payload: { jobId, candidateId },
  };
};
export const getScheduleInterviewDetailsSuccess = (interviewerDetails) => {
  return {
    type: GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS,
    payload: interviewerDetails,
  };
};
export const getScheduleInterviewDetailsFalied = (errormessage) => {
  return {
    type: GET_SCHEDULER_INTERVIEW_DETAILS_FAIL,
    payload: { errormessage },
  };
};

/**get interviewer data */
export const getInterviewerData = (jobId, allList) => {
  return {
    type: GET_INTERVIEWERS_DATA,
    payload: { jobId, allList },
  };
};
export const getInterviewerDataSuccess = (interviewerData) => {
  return {
    type: GET_INTERVIEWERS_DATA_SUCCESS,
    payload: interviewerData,
  };
};

export const getInterviewerDataFalied = (interviewerDataError) => {
  return {
    type: GET_INTERVIEWERS_DATA_ERROR,
    payload: interviewerDataError,
  };
};
// add interview rounds
export const addInterviewRound = (json) => {
  return {
    type: POST_INTERVIEW_ROUND,
    payload: { json },
  };
};

export const addInterviewRoundSuccess = (message) => {
  return {
    type: POST_INTERVIEW_ROUND_SUCCESS,
    payload: message,
  };
};

export const addInterviewRoundFail = (errormessage) => {
  return {
    type: POST_INTERVIEW_ROUND_FAIL,
    payload: { errormessage },
  };
};
export const scheduleInterview = (json) => {
  return {
    type: SCHEDULE_INTERVIEW,
    payload: { json },
  };
};

export const scheduleInterviewSuccess = (message) => {
  return {
    type: SCHEDULE_INTERVIEW_SUCCESS,
    payload: message,
  };
};

export const scheduleInterviewFail = (errormessage) => {
  return {
    type: SCHEDULE_INTERVIEW_FAILURE,
    payload: { errormessage },
  };
};

export const addInterviewer = (obj) => {
  return {
    type: ADD_NEW_INTERVIEWER,
    payload: obj,
  };
};

export const addInterviewerSuccess = (obj) => {
  return {
    type: ADD_NEW_INTERVIEWER_SUCCESS,
    payload: obj,
  };
};
export const addInterviewerFailed = (obj) => {
  return {
    type: ADD_NEW_INTERVIEWER_FAILED,
    payload: obj,
  };
};

export const updateInterviewDetails = (obj) => {
  return {
    type: UPDATE_INTERVIEW_DETAILS,
    payload: obj,
  };
};

export const updateInterviewDetailsSuccess = (obj) => {
  return {
    type: UPDATE_INTERVIEW_DETAILS_SUCCESS,
    payload: obj,
  };
};
export const updateInterviewDetailsFalied = (errormessage) => {
  return {
    type: UPDATE_INTERVIEW_DETAILSS_FAIL,
    payload: { errormessage },
  };
};
export const rejectCandiate = (data) => {
  return {
    type: REJECT_CANDIDATE,
    payload: { data },
  };
};
export const rejectCandiateFailed = (error) => {
  return {
    type: REJECT_CANDIDATE_FAILURE,
    payload: { error },
  };
};
export const rejectCandiateSuccess = (success) => {
  return {
    type: REJECT_CANDIDATE_SUCCESS,
    payload: success,
  };
};

export const getInterviewRounds = (jobId) => {
  return {
    type: GET_INTERVIEW_ROUNDS,
    payload: { jobId },
  };
};

export const getInterviewRoundsSuccess = (data) => {
  return {
    type: GET_INTERVIEW_ROUNDS_SUCCESS,
    payload: data,
  };
};

export const getInterviewRoundsFailed = (error) => {
  return {
    type: GET_INTERVIEW_ROUNDS_FAILURE,
    payload: error,
  };
};

// AI Interview Recordings
export const getInterviewRecordings = (interviewId) => {
  return {
    type: GET_INTERVIEW_RECORDINGS,
    payload: { interviewId },
  };
};

export const getInterviewRecordingsSuccess = (interviewId, data) => {
  return {
    type: GET_INTERVIEW_RECORDINGS_SUCCESS,
    payload: { interviewId, data },
  };
};

export const getInterviewRecordingsFailure = (interviewId, error) => {
  return {
    type: GET_INTERVIEW_RECORDINGS_FAILURE,
    payload: { interviewId, error },
  };
};
